import React from 'react'
import FriendButtonListEntry from './FriendButtonListEntry.js';
import {friendElement,committeeElement,Breadcrumb} from './myFunctions.js';
import QuarterlyMeetingList from './QuarterlyMeetingList.js';
export default function OhioYearlyMeeting({oym, dropBreadcrumb,authenticated}) {
    console.log("OhioYearlyMeeting:", authenticated,oym);
    function officeElement(heading,office){
        console.log("officeElement", heading);
        let friend = oym.objectRef(office.tenure.friend);
        let onClickOfficeName = function (){
            clickOfficeName(office);
        };
        return(
             <tr>
                <td>
                    <span style={{cursor: "pointer"}} onClick={onClickOfficeName}>{heading}:</span> &nbsp;
                </td>
                <td>
                    <FriendButtonListEntry friend={friend} oym={oym} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated}/>
               </td>
             </tr>
            
        )
    }
    function clickOfficeName(office){
        console.log("Clicking for ",office);
        dropBreadcrumb(new Breadcrumb(office.name,committeeElement(oym,office,dropBreadcrumb)));
    }
    let clerk = oym.objectRef("Office_Yearly Meeting Clerk");
    let assistantClerk = oym.objectRef("Office_Yearly Meeting Assistant Clerk")
    let treasurer = oym.objectRef("Office_Treasurer");
    let assistantTreasurer = oym.objectRef("Office_Assistant Treasurer");
    let recorder = oym.objectRef("Office_Recorder");
    let assistantRecorder = oym.objectRef("Office_Assistant Recorder");
    console.log("OYM authenticated "+authenticated);
    return (
        <div>
            <b><font size="6">Ohio Yearly Meeting</font></b>
            <table><tbody>
            {officeElement("Clerk",clerk)}
            {officeElement("Assistant Clerk",assistantClerk)}
            {officeElement("Treasurer",treasurer)}
            {officeElement("Assistant Treasurer",assistantTreasurer)}
            {officeElement("Recorder",recorder)}
            {officeElement("Assistant Recorder",assistantRecorder)}
            </tbody></table>
            <QuarterlyMeetingList oym={oym} list={oym.data.quarterlyMeetings[1]} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated}/>
        </div>
    )
}
